

import { Button } from "@/components/ui/button";
import { Download, Loader2 } from "lucide-react";
import { useI18n } from "@/i18n";
import { useDownload } from "@/hooks/useDownload";

const Footer = () => {
    const { language } = useI18n();
    const { isLoading, downloadLatest } = useDownload();

    return (
        <footer className="py-20 bg-[hsl(222,47%,11%)] text-white">
            <div className="container mx-auto px-4">
                <div className="max-w-4xl mx-auto text-center">
                    <h2 className="text-4xl md:text-5xl font-bold mb-6">
                        {language === 'en' ? 'Ready to Run AI Locally?' : '准备好本地运行 AI 了吗？'}
                    </h2>
                    <p className="text-xl mb-4 text-white/80">
                        {language === 'en' ? 'Download Estha for macOS and start using today.' : '立即下载 Estha，开始在您的 Mac 上运行 AI。'}
                    </p>

                    <p className="text-xl mb-8 text-white/80">
                        {language === 'en' ? 'System Requirements: Apple M4/M5 · 32GB RAM minimum' : '系统要求： Apple M4/M5 芯片 · 至少 32GB 内存。'}
                    </p>
                    <Button
                        size="lg"
                        variant="secondary"
                        className="text-lg px-8 bg-primary text-primary-foreground hover:bg-primary/90"
                        onClick={downloadLatest}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <>
                                <Loader2 className="mr-2 animate-spin"/>
                                {language === 'en' ? 'Loading...' : '加载中...'}
                            </>
                        ) : (
                            <>
                                <Download className="mr-2"/>
                                {language === 'en' ? 'Download Estha for macOS' : '下载 Estha macOS 版'}
                            </>
                        )}
                    </Button>

                    <div className="mt-16 pt-8 border-t border-white/20">
                        <p className="text-sm text-white/60">© 2025 Estha. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
